export default "/images/telerad_docs.svg?5574619f330a4875cd9f8640069190ea";